import { FlexBox } from '@ardoq/layout';
import { EditingReportDataInteractiveRowViewState } from './types';
import { Text } from '@ardoq/typography';
import { pluralizeWithCount } from '@ardoq/common-helpers';
import { type I18nLocale, t } from '@ardoq/i18n';
import { TableControlsInteractiveRow } from './TableControlsInteractiveRow';

type EditingReportDataInteractiveRowProps = {
  state: EditingReportDataInteractiveRowViewState;
  i18nLocale: I18nLocale;
};

export const EditingReportDataInteractiveRow = ({
  state,
  i18nLocale,
}: EditingReportDataInteractiveRowProps) => {
  return (
    <TableControlsInteractiveRow i18nLocale={i18nLocale}>
      <FlexBox gap="xsmall" align="center" width="full" justify="end">
        <Text variant="text2" color="textSubtle">
          {t(
            i18nLocale,
            'inventory:interactiveRow.componentCount',
            { count: state.totalNumberOfMatchingRows },
            pluralizeWithCount('component', state.totalNumberOfMatchingRows)
          )}
        </Text>
      </FlexBox>
    </TableControlsInteractiveRow>
  );
};
